// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customDate .q-field__before {\n  padding-top: 5px;\n}\n.custom-text-before {\n  font-size: 14px;\n  border: 1px solid rgba(0, 0, 0, 0.15) !important;\n  border-right: 0 !important;\n  border-radius: 4px 0 0 0;\n  line-height: 31px;\n  height: 33px !important;\n  min-height: 33px !important;\n}\n.custom-multi-field .q-field__native {\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
